import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import LanguageDetector from 'i18next-browser-languagedetector'

import en from './locales/en.json'
import ar from './locales/ar.json'
import gr from './locales/gr.json'

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    supportedLngs: ['en', 'ar', 'gr'],
    resources: {
      en: { translation: en },
      ar: { translation: ar },
      gr: { translation: gr },
    },
    fallbackLng: 'en',
    debug: false,
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      lookupLocalStorage: 'lang',
      caches: ['localStorage'],
      convertDetectedLanguage: (lng) => {
        if (!lng || typeof lng !== 'string') return lng;
        const base = lng.split(/[-_]/)[0].toLowerCase();
        if (base === 'de') return 'gr';
        return base;
      },
    },
  })

export default i18n
